import "./App.scss";
import React from "react";
import { useSelector } from "react-redux";
import {
  Routes,
  Route,
  Navigate,
  Outlet,
  BrowserRouter,
} from "react-router-dom";
import LoginView from "./interfaces/views/Login/Login";
import Signup from "./interfaces/views/Signup/Signup";
import { ConfigProvider, Modal } from "antd";
import { IProtectedRouteProps, RoleType } from "./interfaces/index";
import ConnectionEventEmiter from "./shared/events";
import Profile from "./interfaces/views/Profile/Profile";
import Entity from "./interfaces/views/Admin/Entities/Entity";
import Products from "./interfaces/views/Admin/Products/Products";
import Groups from "./interfaces/views/Admin/Groups/Groups";
import Searchers from "./interfaces/views/Admin/Searchers/Searchers";
import Universities from "./interfaces/views/Admin/Universities/Universities";
import Commons from "./interfaces/views/Admin/commons/Commons";
import Projects from "./interfaces/views/Admin/Projects/Projects";
import Announcement from "./interfaces/views/Admin/Announcement/Announcement";
import Events from "./interfaces/views/Admin/Events/Events";
import Analytics from "./interfaces/views/Admin/Analiytics/Analytics";
import CommonsCapacities from "./interfaces/views/Admin/CommonsCapacities/CommonsCapacities";
import Users from "./interfaces/views/Admin/Users/Users";
import NoFound from "./interfaces/views/NoFound/NoFound";
import Dashboard from "./interfaces/views/Dashboard/dashboard";
import es from "antd/locale/es_ES";
import dayjs from "dayjs";
import "dayjs/locale/es";
import EventsListing from "./interfaces/views/EventsListing/EventsListing";
import AnnouncementSListings from "./interfaces/views/AnnouncementsListing/AnnouncementListing";
dayjs.locale("es");

const listener = new ConnectionEventEmiter(document);
listener.subscribe({
  event: "event_response",
  listener: (event) => {
    const { status, message } = event.detail.data;

    if (status === 400) {
      Modal.error({
        title: "UNAB - Connection",
        content: message,
        onOk: () => {},
      });
    }

    if (status === 401) {
      Modal.error({
        title: "UNAB - Connection",
        content: message,
        onOk: () => {
          localStorage.clear();
          window.location.href = "/login";
        },
      });
    }

    if (status === 404) {
      Modal.error({
        title: "UNAB - Connection",
        content: message,
        onOk: () => {
          window.location.reload();
        },
      });
    }

    if (status === 500) {
      Modal.error({
        title: "UNAB - Connection",
        content: message,
        onOk: () => {
          window.location.reload();
        },
      });
    }
  },
});

const App: React.FC = () => {
  const user = useSelector((state: any) => {
    return state.user.user;
  });

  console.log("usr", user);

  const ProtectedRouteMiddleware = (props: IProtectedRouteProps) => {
    const { user, redirectPath } = props;

    if (!user) {
      return <Navigate to={redirectPath ?? "/login"} replace />;
    }

    switch (user.role.name) {
      case RoleType.Public:
        return <Navigate to={"/404"} replace />;
      case RoleType.KnowledgeConsumer:
        return <Outlet />;
      case RoleType.Admin:
        return <Outlet />;
      default:
        break;
    }

    return <Outlet />;
  };

  return (
    <ConfigProvider locale={es} theme={{ token: { colorPrimary: "#f37221" } }}>
      <BrowserRouter>
        <Routes>
          <Route
            index
            path="/"
            element={<Navigate to={"/events-listing"}></Navigate>}
          />
          <Route
            path="/announcements-listing/:announcementId?"
            element={<AnnouncementSListings />}
          ></Route>
          <Route
            path="/events-listing/:eventId?"
            element={<EventsListing />}
          ></Route>
          <Route
            path="login"
            element={(() => {
              if (user) return <Navigate to={"/"} />;
              else return <LoginView />;
            })()}
          />
          <Route element={<ProtectedRouteMiddleware user={user?.me} />}>
            <Route path="/profile" element={<Profile />}></Route>
            <Route path="/entity" element={<Entity />}></Route>
            <Route path="/searchers" element={<Searchers />}></Route>
            <Route path="/groups" element={<Groups />}></Route>
            <Route path="/ies" element={<Universities />}></Route>
            <Route path="/commons/:actor" element={<Commons />}></Route>
            <Route
              path="/commons-capacities/:capacity"
              element={<CommonsCapacities />}
            ></Route>
            <Route path="/products" element={<Products />}></Route>
            <Route path="/projects" element={<Projects />}></Route>
            <Route path="/announcement" element={<Announcement />}></Route>
            <Route path="/events" element={<Events />}></Route>

            <Route path="/analytics" element={<Analytics />}></Route>
            <Route path="/users" element={<Users />}></Route>
          </Route>
          <Route path="/*" element={<Dashboard />}></Route>
          <Route path="/register" element={<Signup />}></Route>
          <Route path="/404" element={<NoFound />}></Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
};

export default App;
